import { jsx as _jsx } from "react/jsx-runtime";
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { IconsLibrary } from 'shared/components/fields/icon';
import { heating_circuits_icons } from 'shared/components/fields/icon/icons';
import { useHeatingCircuitsItemState } from 'z3k-settings/climatic/heating-circuits-item/lib/useHeatingCircuitsItemState';
import { useContext } from 'react';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
export function CircuitIcon() {
    const { icon, for_circuit } = useHeatingCircuitsItemState();
    const { replace_device_ui_settings, deviceSettings } = useContext(Z3KSettingsEditor);
    return (_jsx(SettingCard, { title: "\u0412\u044B\u0431\u043E\u0440 \u0438\u043A\u043E\u043D\u043A\u0438 \u043A\u043E\u043D\u0442\u0443\u0440\u0430", children: _jsx(IconsLibrary, { icons: heating_circuits_icons, onChange: (value) => {
                replace_device_ui_settings({
                    ...deviceSettings?.ui_settings,
                    icons: {
                        ...deviceSettings?.ui_settings?.icons,
                        heating_circuits: {
                            ...deviceSettings?.ui_settings?.icons?.heating_circuits,
                            [for_circuit.id]: value,
                        },
                    },
                });
            }, value: icon }) }));
}
